package com.essntl.features.tag.ui.alltags

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.tag.ui.alltags.components.TagItem
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlin.collections.orEmpty

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun AllTagsScreen(
    state: AllTagsState,
    onEvent: (AllTagsEvent) -> Unit,
    onNavigation: (AllTagsNavigation) -> Unit,
) {
    var searchText by remember { mutableStateOf("") }

    val filteredTags = remember(searchText, state.getAllTags.data) {
        state.getAllTags.data
            .orEmpty()
            .filter {
                it.name.contains(
                    searchText.trim(),
                    ignoreCase = true,
                )
            }.sortedBy { it.name.lowercase() }
    }

    Column(
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.Start,
        modifier = Modifier.fillMaxSize(),
    ) {
        Column(
            verticalArrangement = Arrangement.spacedBy(1.spacing),
            modifier = Modifier.fillMaxWidth(),
        ) {
            Text(
                text = "Tags",
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.h4SemiBold20,
            )

            EsInput(
                value = searchText,
                onValueChange = { searchText = it },
                prefix = {
                    EsLargeIcon(
                        res = EsIcons.Search,
                    )
                },
                placeholder = "Search",
                modifier = Modifier.width(260.dp),
            )
        }

        Spacer(modifier = Modifier.height(2.spacing))

        if (state.getAllTags.isLoading) EsSpinner()
        else if (state.getAllTags.isFailure)
            Text(
                text = "Something goes wrong!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
            )
        else if (filteredTags.isEmpty())
            Text(
                text = "No tags found!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
            )
        else
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(2.spacing),
                verticalArrangement = Arrangement.spacedBy(2.5.spacing),
                modifier = Modifier.fillMaxWidth(),
            ) {
                for (tag in filteredTags)
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(1.spacing),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        TagItem(tag = tag)

                        EsSmallOutlineIconButton(
                            iconRes = EsIcons.Edit,
                            onClick = {
                                onNavigation(AllTagsNavigation.EditTag(tag))
                            },
                        )
                    }
            }
    }
}